<template>
    <footer id="footer" class="footer-wrapper">
        <div class="wrapper_fter_end">
            <div class="container ner_responesize">
                <div class="row">
                    <div class="wp_item_footer wp_item_footer1">
                        <div class="item_footer">
                            <img src="../assets/images/logo.png" alt="" class="logoFooter">
                            <p v-if="!readMore[1]">{{ content.substring(0, 232) + '...' }} <span @click="showMore(1)" class="spanmore">Xem thêm</span></p>
                            <p v-if="readMore[1]">{{ content }} <span @click="showLess(1)" class="spanless">Thu gọn</span></p>
                            <div class="imgfter_end">
                                <img src="../assets/images/ft1.png" alt="">
                            </div>
                        </div>
                    </div>
                    <div class="wp_item_footer wp_item_footer2">
                        <div class="item_footer">
                            <h3 class="title_footer"><img src="../assets/images/vm.png" alt=""> Liên kết nhanh</h3>
                            <ul>
                                <li><a :href="listlinkGk.agency_cooperation" target="_blank"><img src="../assets/images/right.png" alt=""> HỢP TÁC ĐẠI LÝ</a></li>
                                <li><a :href="listlinkGk.clause" target="_blank"><img src="../assets/images/right.png" alt=""> ĐIỀU KOẢN VÀ ĐIỀU KIỆN</a></li>
                                <li><a :href="listlinkGk.introduce" target="_blank"><img src="../assets/images/right.png" alt=""> GIỚI THIỆU VỀ GK88</a></li>
                                <li><a :href="listlinkGk.play_responsibly" target="_blank"><img src="../assets/images/right.png" alt=""> CHƠI CÓ TRÁCH NHIỆM</a></li>
                                <li><a :href="listlinkGk.disclaimer" target="_blank"><img src="../assets/images/right.png" alt=""> MIỄN TRÁCH NHIỆM</a></li>
                                <li><a :href="listlinkGk.privacy_policy" target="_blank"><img src="../assets/images/right.png" alt=""> CHÍNH SÁCH BẢO MẬT</a></li>
                                <li><a :href="listlinkGk.faq" target="_blank"><img src="../assets/images/right.png" alt=""> CÂU HỎI THƯỞNG GẶP</a></li>
                            </ul>
                        </div>
                    </div>
                    <div class="wp_item_footer wp_item_footer3">
                        <div class="item_footer">
                            <h3 class="title_footer"><img src="../assets/images/b.png" alt=""> Tổng hợp</h3>
                            <ul>
                                <li><a :href="listlinkGk.casino" target="_blank"><img src="../assets/images/right.png" alt=""> CASINO</a></li>
                                <li><a :href="listlinkGk.jackpot" target="_blank"><img src="../assets/images/right.png" alt=""> NỔ HŨ</a></li>
                                <li><a :href="listlinkGk.sport" target="_blank"><img src="../assets/images/right.png" alt=""> THỂ THAO</a></li>
                                <li><a :href="listlinkGk.game_3d" target="_blank"><img src="../assets/images/right.png" alt=""> GAME BÀI 3D</a></li>
                                <li><a :href="listlinkGk.fish_shooting" target="_blank"><img src="../assets/images/right.png" alt=""> BẮN CÁ</a></li>
                                <li><a :href="listlinkGk.lottery" target="_blank"><img src="../assets/images/right.png" alt=""> XỔ SỐ</a></li>
                                <li><a :href="listlinkGk.gamechicken" target="_blank"><img src="../assets/images/right.png" alt=""> ĐÁ GÀ</a></li>
                            </ul>
                        </div>
                    </div>
                    <div class="wp_item_footer wp_item_footer4">
                        <div class="item_footer">
                            <img src="../assets/images/ft.png" alt="">
                        </div>
                    </div>
                </div>
                <div class="parthner_footer">
                    <img src="../assets/images/ft2.png" alt="">
                </div>
                <div class="preview_footer">
                    <div class="textpreview">
                        <p>Chúng tôi có các trò chơi phù hợp với mọi người chơi khi chơi Casino Online. Không chỉ có hàng trăm trò chơi Casino, chúng tôi còn gửi tặng nhiều phần thưởng và khuyến mãi cho các thành viên của mình.</p>
                    </div>
                </div>
            </div>
            <div class="copyright_f8">
                <p>Copyright © GK88 Reserved</p>
            </div>
        </div>
    </footer>
    
</template>

<script>
export default {
    name: 'Footer_live',
    data () {
        return {
            readMore: [false],
            content: 'GK88 là một trong những nhà cái trực tuyến uy tín hàng đầu tại châu Á, đặc biệt được biết đến rộng rãi tại Việt Nam. GK88 được cấp phép hoạt động bởi các cơ quan uy tín quốc tế như PAGCOR (Philippines), Isle of Man và Curacao Gaming.Đây là những tổ chức có tiêu chuẩn nghiêm ngặt trong việc cấp phép cho các nhà cái trực tuyến, đảm bảo rằng mọi hoạt động của GK88 đều tuân thủ pháp luật và minh bạch . Nhà cái này sử dụng công nghệ mã hóa SSL 256-bit kết hợp với tường lửa hiện đại và hệ thống giám sát liên tục để bảo vệ thông tin cá nhân và giao dịch của người chơi. Điều này giúp ngăn chặn mọi hành vi gian lận và tấn công mạng, tạo môi trường chơi game an toàn và công bằng Với hơn 10 triệu thành viên đăng ký và nhiều giải thưởng danh giá, GK88 đã chứng tỏ được uy tín và chất lượng dịch vụ của mình. Nhà cái này liên tục cải tiến và nâng cấp để đáp ứng nhu cầu ngày càng cao của người chơi',
            listlinkGk: ''
        }
    },
    created() {
        this.getInfoLink()
    },
    components: {
        
    },
    methods: {
        showMore(index) {
            this.readMore[index] = true;
        },
        showLess(index) {
            this.readMore[index] = false;
        },
        getInfoLink () {
            this.axios.get(this.api_previewLink).then((response) => {
                this.listlinkGk = response.data.data.list_data
            })
        },
    }
}
</script>